import { Injectable, NgModule } from '@angular/core';
import { Socket, SocketIoModule } from 'ngx-socket-io';
import { ConfigLoaderService } from './config/configloader.service';

@Injectable()
export class PySyncSocket extends Socket {
  constructor(private configService: ConfigLoaderService) {
    super({
      url: configService.settings.pySyncServer.url,
      options: configService.settings.pySyncServer.options
    });
  }
}

@NgModule({
  declarations: [],
  imports: [
  SocketIoModule
  ],
  providers: [PySyncSocket],
  bootstrap: []
  })
export class PySyncSocketModule { }
